<template>
  <a-form-model layout="vertical" :model="form" :rules="rules" ref="form">
    <a-row :gutter="24" class="form-row-margin">
      <a-col :span="12">
        <a-form-model-item :label="$t('safety.deviceName')" prop="deviceName">
          <a-input
            :placeholder="$t('safety.inputDeviceName')"
            v-model="form.deviceName"
            :maxLength="32"
          />
        </a-form-model-item>
      </a-col>
      <a-col :span="12">
        <a-form-model-item :label="$t('safety.deviceCode')" prop="deviceCode">
          <a-input
            :placeholder="$t('safety.inputDeviceCode')"
            v-model="form.deviceCode"
            :disabled="!canEdit"
            :maxLength="128"
          />
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row :gutter="24" class="form-row-margin">
      <a-col :span="12">
        <a-form-model-item label="设备密钥" prop="deviceKey">
          <a-input
            placeholder="请输入设备密钥"
            v-model="form.deviceKey"
            :disabled="!canEdit"
            :maxLength="16"
          />
        </a-form-model-item>
      </a-col>
      <a-col :span="12">
        <a-form-model-item :label="$t('safety.belongProject')" prop="projectId">
          <a-select
            show-search
            allowClear
            v-model="form.projectId"
            :placeholder="$t('safety.chooseProject')"
            @change="handleProjectChange"
            option-filter-prop="children"
            :filter-option="true"
          >
            <a-select-option
              :value="item.pkId"
              v-for="item in projectList"
              :key="item.pkId"
            >
              {{ item.projectName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row :gutter="24" class="form-row-margin">
      <a-col :span="12">
        <a-form-model-item label="联动设备">
          <a-select
            allowClear
            v-model="form.relatedDeviceType"
            placeholder="请选择设备类型"
            style="margin-bottom: 10px;"
            @change="handleTypeChange"
          >
            <a-select-option value="DUST">
              扬尘设备监控
            </a-select-option>
            <a-select-option value="TCSF">
              塔吊设备监控
            </a-select-option>
          </a-select>
          <a-select
            show-search
            allowClear
            v-model="form.relatedDeviceId"
            placeholder="请选择设备"
            option-filter-prop="children"
            :filter-option="true"
          >
            <a-select-option
              :value="item.pkId"
              v-for="item in devices"
              :key="item.pkId"
            >
              {{ item.deviceName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
      <a-col :span="12">
        <a-form-model-item :label="$t('common.remark')" prop="remark">
          <a-input
            :placeholder="$t('safety.inputRemark')"
            v-model="form.remark"
            :maxLength="128"
          />
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :span="12">
        <a-form-model-item label="绑定NVR设备">
          <a-select
            show-search
            allowClear
            option-filter-prop="children"
            :filter-option="true"
            v-model="form.extData.nvrDeviceId"
            @search="v => selectSearch(v)"
          >
            <a-select-option
              v-for="item in monitoringDevices"
              :key="item.pkId"
              :value="item.pkId"
            >
              {{ item.deviceName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { deviceTypeEnum } from '@/enum/device';
import FormCommon from '@/views/green-construction/components/mixins/form-common';
import { deviceList } from '@/services/device-manage/device';
import { Debounce } from 'lodash-decorators';

@Component()
export default class SurveillanceForm extends mixins(FormCommon) {
  created() {
    this.getMonitoringDeviceList();
  }
  form = {
    deviceName: '',
    deviceCode: '',
    projectId: undefined,
    relatedDeviceType: undefined,
    relatedDeviceId: undefined,
    deviceKey: '',
    remark: '',
    extData: {
      nvrDeviceId: undefined,
    },
  };
  rules = {
    deviceName: [
      {
        required: true,
        message: this.$t('safety.requiredDeviceName'),
      },
    ],
    deviceCode: [
      {
        required: true,
        message: this.$t('safety.requiredDeviceCode'),
      },
    ],
    deviceKey: [
      {
        required: true,
        message: '设备密钥不能为空',
      },
    ],
  };
  monitorTypes = [];
  get postData() {
    return {
      deviceGroup: deviceTypeEnum.VS.deviceGroup,
      deviceName: this.form.deviceName,
      deviceCode: this.form.deviceCode,
      relatedDeviceType: this.form.relatedDeviceType,
      relatedDeviceId: [this.form.relatedDeviceId],
      idxProjectId: this.form.projectId,
      remark: this.form.remark,
      deviceKey: this.form.deviceKey,
      extData: this.form.extData,
    };
  }
  async initFormData(data) {
    this.form.deviceName = data.deviceName;
    this.form.deviceCode = data.deviceCode;
    this.form.projectId = data.idxProjectId;
    this.form.remark = data.remark;
    this.form.deviceKey = data.encryptionKey;
    this.form.extData.nvrDeviceId = data.extData.nvrDeviceId;
    if (data.relatedDevice.length) {
      await this.getDeviceList(data.relatedDevice[0].deviceGroup);
      this.form.relatedDeviceType = data.relatedDevice[0].deviceGroup;
      this.form.relatedDeviceId = data.relatedDevice[0].pkId;
    }
  }
  devices = [];
  async getDeviceList(type) {
    const params = {
      projectId: this.form.projectId,
      query: {
        current: 1,
        size: 500,
      },
    };
    const { records } = await deviceList(
      params,
      deviceTypeEnum[type].deviceGroup,
    );
    this.devices = records;
  }
  monitoringDevices = [];
  async getMonitoringDeviceList(device = undefined) {
    const params = {
      device,
      deviceType: 'NVR',
      query: {
        current: 1,
        size: 200,
      },
    };
    const { records } = await deviceList(
      params,
      deviceTypeEnum['VS'].deviceGroup,
    );
    this.monitoringDevices = records;
  }
  @Debounce(300)
  selectSearch(keyword) {
    this.getMonitoringDeviceList(keyword);
  }
  handleTypeChange(type) {
    this.form.relatedDeviceId = undefined;
    this.getDeviceList(type);
  }
  handleProjectChange() {
    this.form.relatedDeviceId = undefined;
    if (this.form.relatedDeviceType) {
      this.getDeviceList(this.form.relatedDeviceType);
    }
  }
  valid = false;
  verify() {
    if (this.form.relatedDeviceType && !this.form.relatedDeviceId) {
      this.valid = false;
      this.$message.error('请选择设备');
    } else {
      this.valid = true;
    }
  }
}
</script>

<style></style>
